import {ReactElement, useState} from 'react';
import {AddToCartButton, Money} from '@shopify/hydrogen';
import {ProductVariant} from '@shopify/hydrogen/storefront-api-types';
import QuantityAdjuster from './QuantityAdjuster.client';
import {useShopifyProductVariantMetafields} from '../hooks';
import classNames from 'classnames';
import {getIsVariantAvailableForSale} from '../utils/variants';

interface ProductMarketplaceItemProps {
  productVariant: ProductVariant;
  hidden: boolean;
}

export default function ProductMarketplaceItem({
  productVariant,
  hidden,
}: ProductMarketplaceItemProps): ReactElement {
  const [quantity, setQuantity] = useState(1);
  const {
    metafields,
    title,
    price,
    availableForSale: shopifyAvailableForSale,
  } = productVariant;

  const availableForSale = getIsVariantAvailableForSale(productVariant);

  const {metafieldsKeyValue} = useShopifyProductVariantMetafields(metafields);

  return (
    <div
      className={classNames('marketing-pricing__row', {
        'marketing-pricing__row-hidden': hidden,
      })}
    >
      <div className="marketing-pricing__cell marketing-pricing__cell-1">
        <h3 className="title-2">{title}</h3>
      </div>
      <div className="marketing-pricing__cell marketing-pricing__cell-2">
        {availableForSale && (
          <div>
            <div className="price-item">
              <div>
                $
                <Money data={price} as="span" withoutCurrency />
              </div>
            </div>
            <div className="marketing-pricing__cell__shipping">+ Shipping</div>
          </div>
        )}
      </div>
      <div className="marketing-pricing__cell marketing-pricing__cell-3">
        {metafieldsKeyValue.sellerShopIsPartner &&
          availableForSale &&
          shopifyAvailableForSale && (
            <QuantityAdjuster onChange={setQuantity} quantity={quantity} />
          )}
      </div>
      <div className="marketing-pricing__cell marketing-pricing__cell-4">
        <div className="marketing-pricing__cell-4__buttons">
          <p className="mb-10">
            {availableForSale ? (
              shopifyAvailableForSale &&
              metafieldsKeyValue.sellerShopIsPartner && (
                <>
                  <AddToCartButton
                    variantId={productVariant.id}
                    quantity={quantity}
                    className="button button_size_large"
                    type="button"
                    title="Add to cart"
                    accessibleAddingToCartLabel="Adding item to your cart"
                  >
                    Add to cart
                  </AddToCartButton>
                  {/* <Link
                    to={`/shop/?partnerStores=${title}`}
                    className="button button_size_medium button_color_gray_1"
                    title="Go to seller"
                  >
                    Go to seller
                  </Link> */}
                </>
              )
            ) : (
              <button
                disabled
                className="button button_size_large button_color_gray_1"
                type="button"
                title="Out of stock"
              >
                Out of stock
              </button>
            )}
          </p>
        </div>
        {metafieldsKeyValue.sellerNote && (
          <p className="marketing-pricing__cell-4__buttons-text">
            {metafieldsKeyValue.sellerNote}
          </p>
        )}
      </div>
    </div>
  );
}
